import { Button, Modal, Spinner } from '@platform/components';
import { CSVLink } from 'react-csv';

type DownloadResultsModalProps = {
  onClose: () => void;
  /** Rows to write to the CSV, one object per line. */
  rows: object[];
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  /** Prefix for the downloaded file, e.g. `pro_export`. */
  filenamePrefix?: string;
};

/**
 * Presentational shell for an admin search export. It does no fetching of its own —
 * each search type has a small wrapper (e.g. `ProUserDownloadModal`) that calls the
 * generated export hook and hands the rows down.
 */
export const DownloadResultsModal = ({
  onClose,
  rows,
  isLoading,
  isError,
  isSuccess,
  filenamePrefix = 'export',
}: DownloadResultsModalProps) => {
  return (
    <Modal
      variant='dialog'
      headerDivision='divider'
      title='Download Results'
      isOpen={true}
      onClose={onClose}
      ignoreExtraPadding={true}
    >
      <>
        {isLoading && <Spinner />}
        {isError && <p>Error fetching download data.</p>}
        {isSuccess && (
          <div className='flex justify-center gap-2'>
            <Button
              variant='secondary-danger'
              size='sm'
              additionalClassnames='w-fit'
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant='primary'
              size='sm'
              additionalClassnames='w-fit'
              isDisabled={rows.length === 0}
            >
              {rows.length > 0 && (
                <CSVLink
                  filename={`${filenamePrefix}_${new Date().toISOString().replace(/[:.]/g, '-')}.csv`}
                  data={rows}
                >
                  Download csv
                </CSVLink>
              )}
            </Button>
          </div>
        )}
      </>
    </Modal>
  );
};
